//@ts-nocheck
import { Ace } from 'ace-builds';

export const getCustomStatementsSQLHighlightingMode = (statements: Ace.HighlightRule[]): Ace.SyntaxMode => {
  class SQLHighlightRules extends window.ace.acequire('ace/mode/pgsql_highlight_rules').PgsqlHighlightRules {
    constructor() {
      super();
      this.$rules.statement.unshift(...statements);
    }
  }

  class SQLCustomMode extends window.ace.acequire('ace/mode/pgsql').Mode {
    constructor() {
      super();
      this.HighlightRules = SQLHighlightRules;
    }
  }

  return new SQLCustomMode();
};

export const getCustomStatementsTextHighlighting = (statements: Ace.HighlightRule[]): Ace.SyntaxMode => {
  class TextHighlightRules extends window.ace.acequire('ace/mode/text_highlight_rules').TextHighlightRules {
    constructor() {
      super();
      this.$rules.start.unshift(...statements);
    }
  }

  class TextCustomMode extends window.ace.acequire('ace/mode/text').Mode {
    constructor() {
      super();
      this.HighlightRules = TextHighlightRules;
    }
  }

  return new TextCustomMode();
};
